import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useLayoutEffect, useRef } from 'react';

gsap.registerPlugin(ScrollTrigger);

const lines = [
  'Keine glatte Perfektion.',
  'Keine höfliche Oberfläche.',
  'Bilder mit Gewicht.',
  'Atmosphäre vor Dekoration.'
];

export default function Manifesto() {
  const root = useRef(null);

  useLayoutEffect(() => {
    if (!root.current || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;

    const context = gsap.context(() => {
      gsap.from('.manifesto__line span', {
        yPercent: 105,
        rotate: 2,
        stagger: 0.12,
        duration: 1.1,
        ease: 'power4.out',
        scrollTrigger: {
          trigger: root.current,
          start: 'top 72%'
        }
      });

      gsap.to('.manifesto__marquee', {
        xPercent: -20,
        ease: 'none',
        scrollTrigger: {
          trigger: root.current,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });
    }, root);

    return () => context.revert();
  }, []);

  return (
    <section className="manifesto" ref={root}>
      <div className="manifesto__marquee" aria-hidden="true">
        STEFAN MALDET / VISUAL PRESSURE / CHARACTER / ATMOSPHERE / EDGE /
      </div>
      <div className="manifesto__lines">
        {lines.map((line) => (
          <p className="manifesto__line" key={line}>
            <span>{line}</span>
          </p>
        ))}
      </div>
    </section>
  );
}
